export class Resource {
  objecttype_DONTACCESS: string;
  id_DONTACCESS: string;
  displayname_DONTACCESS: string;
  description_DONTACCESS: string;
  domain_DONTACCESS: string;
}

export class ResourceWithPermissionHints {
  objecttype_DONTACCESS: ResourceAttributeWithPH<string>;
  id_DONTACCESS: ResourceAttributeWithPH<string>;
  displayname_DONTACCESS: ResourceAttributeWithPH<string>;
  description_DONTACCESS: ResourceAttributeWithPH<string>;
}

export class ResourceAttributeWithPH<T> {
  PermissionHint: string[];
  Values: T;
  SpecialObject?: any;
}
